<h1 class="prf-h1"><ng-content /></h1>
